import React from 'react';
import { x } from '@xstyled/styled-components';
import WhiteCrossIcon from '~/assets/button/white_cross.svg';

const ModalCloseButton = ({
  onClick,
  iconWidth = '20',
  iconHeight = '20',
  iconCursor = 'pointer',
  ...rest
}: {
  onClick: () => void;
  iconWidth?: string;
  iconHeight?: string;
  iconCursor?: string;
}) => (
  <x.div position="absolute" top="-18px" right="-26px" {...rest}>
    <WhiteCrossIcon
      width={iconWidth}
      height={iconHeight}
      onClick={onClick}
      cursor={iconCursor}
    />
  </x.div>
);

export default ModalCloseButton;
